import { Outlet, useLocation } from "react-router-dom";
import { useAdmContext } from "../../hooks/useAdmContext";
import logoPng from "../../assets/logo.png";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleRight,
  faArrowRightFromBracket,
  faClipboardList,
  faDolly,
  faFileLines,
  faLocationDot,
  faTruckFast,
  faUnlock,
  faUserCircle
} from "@fortawesome/free-solid-svg-icons";
import { faUser } from "@fortawesome/free-regular-svg-icons";

import "./style.css"

export function LayoutDashboard() {
  const { logout, usuario } = useAdmContext();
  const { pathname } = useLocation();

  const handleLogout = () => {
    if (!window.confirm("Deseja mesmo sair da sua conta?"))
      return;

    logout();
  }

  const txtTitle = (path: string): string => {

    if (path.includes("/cidades"))
      return "Cidades";

    if (path.includes("/pessoas"))
      return "Pessoas";

    if (path.includes("/veiculos"))
      return "Veículos";

    if (path.includes("/entregas"))
      return "Entregas";

    if (path.includes("/usuarios"))
      return "Usuários";

    if (path.includes("/relatorio"))
      return "Relatório";

    return "Dashboard";
  }

  return (
    <div id="LayoutDashboard">

      <div className="menu">
        <div className="logo" style={{ backgroundImage: `url(${logoPng})` }} />

        <nav>

          <Link to="cidades" className={`navLink ${pathname.includes("/cidades") ? "selected" : ""}`}>
            <FontAwesomeIcon icon={faLocationDot} style={{ fontSize: "18px" }} />
            <p>Cidades</p>
          </Link>

          <Link to="pessoas" className={`navLink ${pathname.includes("/pessoas") ? "selected" : ""}`}>
            <FontAwesomeIcon icon={faUser} style={{ fontSize: "18px" }} />
            <p>Pessoas</p>
          </Link>

          <Link to="veiculos" className={`navLink ${pathname.includes("/veiculos") ? "selected" : ""}`}>
            <FontAwesomeIcon icon={faTruckFast} style={{ fontSize: "18px" }} />
            <p>Veículos</p>
          </Link>

          <Link to="entregas" className={`navLink ${pathname.includes("/entregas") ? "selected" : ""}`}>
            <FontAwesomeIcon icon={faDolly} style={{ fontSize: "18px" }} />
            <p>Entregas</p>
          </Link>

          <Link to="lista" className={`navLink ${pathname.includes("/lista") ? "selected" : ""}`}>
            <FontAwesomeIcon icon={faClipboardList} style={{ fontSize: "18px" }} />
            <p>Lista</p>
          </Link>

          <Link to="usuarios" className={`navLink ${pathname.includes("/usuarios") ? "selected" : ""}`}>
            <FontAwesomeIcon icon={faUnlock} style={{ fontSize: "18px" }} />
            <p>Usuários</p>
          </Link>

          <Link to="relatorio" className={`navLink ${pathname.includes("/relatorio") ? "selected" : ""}`}>
            <FontAwesomeIcon icon={faFileLines} style={{ fontSize: "18px" }} />
            <p>Relatório</p>
          </Link>

        </nav>

      </div>

      <div className="body">

        <div className="faixaTopo">
          <h3>
            <FontAwesomeIcon icon={faAngleRight} />
            {txtTitle(pathname)}
          </h3>
          <FontAwesomeIcon icon={faUserCircle} className="avatarIcon" />
          <div className="avatar">
            {usuario?.nome}
            <FontAwesomeIcon icon={faArrowRightFromBracket} onClick={() => handleLogout()} />
          </div>
        </div>

        <div className="content">
          <Outlet />
        </div>

      </div>

    </div>
  )
}